export enum EventCode {
  None = 0,
  TwillioClientConnectionError = 1,
  TwillioClientRefreshTokenError = 2,

  // reservation codes 100–300
  ReservationCreated = 101,

  // conversation codes 200–400
  ConversationJoined = 301,
  SpecialistComponentOnChannel = 302,
  SpecialistComponentBreakLinkChannelAndReservation = 303,
  SpecialistComponentLinkChannelAndReservation = 304,
}
